export const csv = `UNITID,INSTNM,CITY,STABBR,INSTURL
100654,Alabama A & M University,Normal,AL,www.aamu.edu/
100663,University of Alabama at Birmingham,Birmingham,AL,www.uab.edu
100690,Amridge University,Montgomery,AL,www.amridgeuniversity.edu
100706,University of Alabama in Huntsville,Huntsville,AL,www.uah.edu
100724,Alabama State University,Montgomery,AL,www.alasu.edu
100751,The University of Alabama,Tuscaloosa,AL,www.ua.edu/
100760,Central Alabama Community College,Alexander City,AL,www.cacc.edu
100812,Athens State University,Athens,AL,www.athens.edu
100830,Auburn University at Montgomery,Montgomery,AL,www.aum.edu
100858,Auburn University,Auburn,AL,www.auburn.edu
100937,Birmingham Southern College,Birmingham,AL,www.bsc.edu/
101028,Chattahoochee Valley Community College,Phenix City,AL,www.cv.edu
101073,Concordia College Alabama,Selma,AL,www.ccal.edu/
101143,Enterprise State Community College,Enterprise,AL,www.escc.edu
101161,Coastal Alabama Community College,Bay Minette,AL,www.coastalalabama.edu
101189,Faulkner University,Montgomery,AL,www.faulkner.edu
101240,Gadsden State Community College,Gadsden,AL,www.gadsdenstate.edu
101277,New Beginning College of Cosmetology,Albertville,AL,www.nbccosmetology.com
101286,George C Wallace Community College-Dothan,Dothan,AL,www.wallace.edu
101295,George C Wallace State Community College-Hanceville,Hanceville,AL,www.wallacestate.edu
101301,George C Wallace State Community College-Selma,Selma,AL,www.wccs.edu
101365,Herzing University-Birmingham,Birmingham,AL,www.herzing.edu/
101435,Huntingdon College,Montgomery,AL,www.huntingdon.edu
101453,Heritage Christian University,Florence,AL,www.hcu.edu
101462,J. F. Drake State Community and Technical College,Huntsville,AL,www.drakestate.edu
101471,J F Ingram State Technical College,Deatsville,AL,www.istc.edu
101480,Jacksonville State University,Jacksonville,AL,www.jsu.edu/
101499,Jefferson Davis Community College,Brewton,AL,www.coastalalabama.edu
101505,Jefferson State Community College,Birmingham,AL,www.jeffersonstate.edu/
101514,John C Calhoun State Community College,Tanner,AL,calhoun.edu/
101541,Judson College,Marion,AL,www.judson.edu
101569,Lawson State Community College-Birmingham Campus,Birmingham,AL,www.lawsonstate.edu
101587,University of West Alabama,Livingston,AL,www.uwa.edu
101602,Lurleen B Wallace Community College,Andalusia,AL,www.lbwcc.edu
101648,Marion Military Institute,Marion,AL,www.marionmilitary.edu
101675,Miles College,Fairfield,AL,www.miles.edu
101693,University of Mobile,Mobile,AL,www.umobile.edu
101709,University of Montevallo,Montevallo,AL,www.montevallo.edu
101736,Northwest-Shoals Community College,Muscle Shoals,AL,https://www.nwscc.edu
101879,University of North Alabama,Florence,AL,www.una.edu
101897,Northeast Alabama Community College,Rainsville,AL,https://www.nacc.edu
101912,Oakwood University,Huntsville,AL,www.oakwood.edu
101949,Alabama Southern Community College,Monroeville,AL,www.coastalalabama.edu
101958,Prince Institute-Southeast,Elmhurst,IL,princeinstitute.edu
101994,Reid State Technical College,Evergreen,AL,www.rstc.edu
102030,Bishop State Community College,Mobile,AL,www.bishop.edu
102049,Samford University,Birmingham,AL,www.samford.edu
102058,Selma University,Selma,AL,selmauniversity.edu
102067,Shelton State Community College,Tuscaloosa,AL,www.sheltonstate.edu
102076,Snead State Community College,Boaz,AL,www.snead.edu
102094,University of South Alabama,Mobile,AL,www.southalabama.edu
102234,Spring Hill College,Mobile,AL,www.shc.edu
102261,Southeastern Bible College,Birmingham,AL,sebc.edu/
102270,Stillman College,Tuscaloosa,AL,www.stillman.edu
102298,Talladega College,Talladega,AL,www.talladega.edu
102313,H Councill Trenholm State Community College,Montgomery,AL,www.trenholmstate.edu
102368,Troy University,Troy,AL,www.troy.edu
102377,Tuskegee University,Tuskegee,AL,www.tuskegee.edu
102395,United States Sports Academy,Daphne,AL,www.ussa.edu
102429,Bevill State Community College,Jasper,AL,www.bscc.edu
102553,University of Alaska Anchorage,Anchorage,AK,www.uaa.alaska.edu
102580,Alaska Bible College,Palmer,AK,www.akbible.edu/
102614,University of Alaska Fairbanks,Fairbanks,AK,www.uaf.edu
102632,University of Alaska Southeast,Juneau,AK,www.uas.alaska.edu
102669,Alaska Pacific University,Anchorage,AK,www.alaskapacific.edu
102711,AVTEC-Alaska's Institute of Technology,Seward,AK,www.avtec.edu/
102845,Charter College,Vancouver,WA,www.chartercollege.edu
103501,Alaska Career College,Anchorage,AK,www.alaskacareercollege.edu
103741,Empire Beauty School-Tucson,Tucson,AZ,www.empire.edu
103778,Thunderbird School of Global Management,Glendale,AZ,https://thunderbird.asu.edu/
103811,American Institute of Trucking,Phoenix,AZ,www.ait-schools.com
103893,Carrington College-Phoenix North,Phoenix,AZ,www.carrington.edu
103909,Carrington College-Mesa,Mesa,AZ,www.carrington.edu
103927,Carrington College-Tucson,Tucson,AZ,www.carrington.edu
103945,CollegeAmerica-Flagstaff,Flagstaff,AZ,www.collegeamerica.edu
103954,Arizona Academy of Beauty-East,Tucson,AZ,www.arizonaacademy.com
103963,Arizona Automotive Institute,Glendale,AZ,www.aai.edu
104090,Brookline College-Phoenix,Phoenix,AZ,www.brooklinecollege.edu
104151,Arizona State University-Tempe,Tempe,AZ,www.asu.edu/
104160,Arizona Western College,Yuma,AZ,www.azwestern.edu
104179,University of Arizona,Tucson,AZ,www.arizona.edu
104188,Southwest University of Visual Arts-Tucson,Tucson,AZ,www.suva.edu
104346,Central Arizona College,Coolidge,AZ,www.centralaz.edu
104364,Brown Mackie College-Tucson,Tucson,AZ,www.brownmackie.edu/locations/tucson
104391,Charles of Italy Beauty College,Lake Havasu City,AZ,www.charlesofitaly.edu
104425,Cochise County Community College District,Sierra Vista,AZ,https://www.cochise.edu
104434,Empire Beauty School-Flagstaff,Flagstaff,AZ,www.empire.edu
104443,Empire Beauty School-Chandler,Chandler,AZ,www.empire.edu
104504,Cortiva Institute-Tucson,Tucson,AZ,www.cortiva.com/
104568,Avalon School of Cosmetology-Mesa,Mesa,AZ,avalon.edu/locations/mesa-az/
104577,Eastern Arizona College,Thatcher,AZ,www.eac.edu
104586,Embry-Riddle Aeronautical University-Prescott,Prescott,AZ,prescott.erau.edu/
104665,School of Architecture at Taliesin,Scottsdale,AZ,www.taliesin.edu
104708,Glendale Community College,Glendale,AZ,www.gccaz.edu
104717,Grand Canyon University,Phoenix,AZ,www.gcu.edu
104911,Olympian Academy of Cosmetology,Tempe,AZ,www.internationalacademyofhairdesign.com
105145,GateWay Community College,Phoenix,AZ,www.gatewaycc.edu
105154,Mesa Community College,Mesa,AZ,www.mesacc.edu
105206,Mohave Community College,Kingman,AZ,https://www.mohave.edu
105215,Universal Technical Institute of Arizona Inc-Motorcycle Mechanics Institute Division,Phoenix,AZ,www.uti.edu/
105297,Dine College,Tsaile,AZ,www.dinecollege.edu
105330,Northern Arizona University,Flagstaff,AZ,https://nau.edu/
105349,Northland Pioneer College,Holbrook,AZ,www.npc.edu
105367,Ottawa University-Phoenix,Phoenix,AZ,www.ottawa.edu
105428,Phoenix College,Phoenix,AZ,www.phoenixcollege.edu
105482,Cortiva Institute-Scottsdale,Scottsdale,AZ,www.cortiva.com/
105525,Pima Community College,Tucson,AZ,www.pima.edu
105534,Pima Medical Institute-Tucson,Tucson,AZ,pmi.edu
105543,Pima Medical Institute-Albuquerque,Albuquerque,NM,pmi.edu
105589,Prescott College,Prescott,AZ,www.prescott.edu
105659,Refrigeration School Inc,Phoenix,AZ,https://www.refrigerationschool.com
105668,Rio Salado College,Tempe,AZ,www.rio.maricopa.edu
105677,Roberto-Venn School of Luthiery,Phoenix,AZ,www.roberto-venn.com
105701,Hair Academy of Safford,Safford,AZ,hairacademysafford.com
105747,Scottsdale Community College,Scottsdale,AZ,www.scottsdalecc.edu
105792,South Mountain Community College,Phoenix,AZ,www.southmountaincc.edu
105899,Arizona Christian University,Phoenix,AZ,www.arizonachristian.edu
105987,Tucson College,Tucson,AZ,www.tucsoncollege.edu
106041,Universal Technical Institute of Arizona Inc,Avondale,AZ,www.uti.edu
106102,Western International University,Tempe,AZ,www.west.edu
106111,Empire Beauty School-NW Phoenix,Phoenix,AZ,www.empire.edu
106148,Yavapai College,Prescott,AZ,www.YC.EDU
106245,University of Arkansas at Little Rock,Little Rock,AR,ualr.edu/www/
106263,University of Arkansas for Medical Sciences,Little Rock,AR,www.uams.edu
106306,Arkansas Baptist College,Little Rock,AR,www.arkansasbaptist.edu
106315,Arkansas Beauty School-Little Rock,Little Rock,AR,arkbeautyschool.com
106324,Arkansas Beauty College,Russellville,AR,www.arkansasbeautycollegersvlar.com/
106342,Lyon College,Batesville,AR,www.lyon.edu
106351,Arkansas College of Barbering and Hair Design,North Little Rock,AR,www.arkansascollegeofbarbering.com
106360,Arthur's Beauty College Inc-Fort Smith,Fort Smith,AR,www.arthursbeautycollege.com
106397,University of Arkansas,Fayetteville,AR,www.uark.edu
106412,University of Arkansas at Pine Bluff,Pine Bluff,AR,www.uapb.edu
106449,Arkansas State University-Beebe,Beebe,AR,www.asub.edu
106458,Arkansas State University-Main Campus,Jonesboro,AR,www.astate.edu/
106467,Arkansas Tech University,Russellville,AR,www.atu.edu
106485,University of Arkansas at Monticello,Monticello,AR,www.uamont.edu/
106494,Arthur's Beauty College Inc-Jacksonville,Jacksonville,AR,arthursbeautycollege.com
106546,Baptist Health College-Little Rock,Little Rock,AR,https://www.bhclr.edu
106625,Black River Technical College,Pocahontas,AR,www.blackrivertech.edu
106704,University of Central Arkansas,Conway,AR,www.uca.edu
106713,Central Baptist College,Conway,AR,www.cbc.edu
106795,Cossatot Community College of the University of Arkansas,De Queen,AR,www.cccua.edu/
106810,Crowley's Ridge College,Paragould,AR,www.crc.edu/
106829,Crowley's Ridge Technical Institute,Forrest City,AR,www.crti.tec.ar.us
106883,East Arkansas Community College,Forrest City,AR,https://WWW.EACC.EDU
106892,Eastern College of Health Vocations-Little Rock,Little Rock,AR,www.easterncollege.edu
106908,Imagine-Paul Mitchell Partner School,North Little Rock,AR,paulmitchell.edu/littlerock
106980,National Park College,Hot Springs,AR,www.np.edu
106999,University of Arkansas Community College-Batesville,Batesville,AR,www.uaccb.edu
107044,Harding University,Searcy,AR,www.harding.edu
107071,Henderson State University,Arkadelphia,AR,www.hsu.edu
107080,Hendrix College,Conway,AR,www.hendrix.edu
107099,Hot Springs Beauty College,Hot Springs,AR,hotspringsbeautycollege.com
107123,Jefferson Regional Medical Center School of Nursing,Pine Bluff,AR,www.jrmc.org
107141,John Brown University,Siloam Springs,AR,www.jbu.edu
107220,Career Academy of Hair Design,Springdale,AR,www.beautynwa.com
107293,Academy of Salon and Spa,Fort Smith,AR,www.academysalonspa.com
107318,Arkansas State University Mid-South,West Memphis,AR,www.asumidsouth.edu
107327,Arkansas Northeastern College,Blytheville,AR,www.anc.edu
107442,New Tyler Barber College Inc,North Little Rock,AR,newtylerbarbercollege.edu
107460,North Arkansas College,Harrison,AR,www.northark.edu
107488,Northwest Technical Institute,Springdale,AR,www.nwti.edu
107512,Ouachita Baptist University,Arkadelphia,AR,www.obu.edu
107521,College of the Ouachitas,Malvern,AR,www.coto.edu
107549,Ozarka College,Melbourne,AR,www.ozarka.edu
107558,University of the Ozarks,Clarksville,AR,https://www.ozarks.edu
107585,University of Arkansas Community College-Morrilton,Morrilton,AR,www.uaccm.edu
107600,Philander Smith College,Little Rock,AR,https://www.philander.edu
107619,Phillips Community College of the University of Arkansas,Helena,AR,www.pccua.edu
107637,Southeast Arkansas College,Pine Bluff,AR,www.seark.edu
107655,Professional Cosmetology Education Center,El Dorado,AR,www.pcec.edu
107664,University of Arkansas-Pulaski Technical College,North Little Rock,AR,www.uaptc.edu
107725,University of Arkansas Community College-Hope,Hope,AR,www.uacch.edu
107743,University of Arkansas Community College Rich Mountain,Mena,AR,www.uarichmountain.edu
107789,Paul Mitchell the School-Arkansas,Fayetteville,AR,https://paulmitchell.edu/arkansas/
107831,Searcy Beauty College,Searcy,AR,searcybeautycollege.com/
107840,Shorter College,N Little Rock,AR,www.shortercollege.edu
107877,Williams Baptist College,Walnut Ridge,AR,www.wbcoll.edu
107974,South Arkansas Community College,El Dorado,AR,www.southark.edu
107983,Southern Arkansas University Main Campus,Magnolia,AR,https://www.saumag.edu
107992,Southern Arkansas University Tech,Camden,AR,www.sautech.edu
108065,Velvatex College of Beauty Culture,Little Rock,AR,www.velvatexcollege.com
108092,University of Arkansas-Fort Smith,Fort Smith,AR,uafs.edu/
108232,Academy of Art University,San Francisco,CA,www.academyart.edu
108269,Academy of Chinese Culture and Health Sciences,Oakland,CA,www.acchs.edu
108348,The Academy of Radio and TV Broadcasting,Huntington Beach,CA,WWW.ARBRADIO.COM
108649,Avalon School of Cosmetology-Alameda,Alameda,CA,avalon.edu/locations/alameda-ca/
108667,College of Alameda,Alameda,CA,alameda.peralta.edu/
108807,Allan Hancock College,Santa Maria,CA,www.hancockcollege.edu/
108852,American Academy of Dramatic Arts-Los Angeles,Los Angeles,CA,www.aada.edu
108861,American Baptist Seminary of the West,Berkeley,CA,www.absw.edu
108870,American Film Institute Conservatory,Los Angeles,CA,www.AFI.com
108977,American Beauty College,West Covina,CA,www.americanbeautycollege.com
109040,American Career College-Los Angeles,Los Angeles,CA,americancareercollege.edu/
109086,American Conservatory Theater,San Francisco,CA,www.act-sf.org
109208,American River College,Sacramento,CA,www.arc.losrios.edu/
109350,Antelope Valley College,Lancaster,CA,www.avc.edu
109651,Art Center College of Design,Pasadena,CA,www.artcenter.edu
109721,Associated Technical College-Los Angeles,Los Angeles,CA,www.atcla.edu`
